import { render } from "./Title.vue?vue&type=template&id=c1c07d60&lang=true"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"
script.render = render

export default script